import {SalaryDecisionVI} from "./salary/vi";
import {RewardDecisionVI} from "./reward/vi";
import {AppointmentDecisionVI} from "./appointment/vi";
import {AdmissionDecisionVI} from "./admission/vi";
import {ReasonVI} from "./reason/vi";
import {DismissalDecisionVI} from "./dismissal/vi";
import {TransferDecisionVI} from "./transfer/vi";
import {ContractDecisionVI} from "./contract/vi";

export const DecisionVI = {
    "decision": {
        "titleHeader":"Quyết định",
        "employeeApproval" : "Người duyệt",
        "delete" : "Xóa quyết định thành công" ,
        "placeholder": {
            "decisionNo": "QD001",
            "decisionDate": "DD/MM/YYYY",
            "decisionMaker": "Nhập cấp ra quyết định",
            "validityDate": "DD/MM/YYYY",
            "employee": "Nhập nhân viên",
            "reasonDecision": "Nhập lý do",
            "currentDepartment": "Phòng ban cũ",
            "currentJobPosition": "Vị trí cũ",
            "currentJobTitle": "Chức vụ cũ",
            "currentContractType":" Hợp đồng cũ",
            "newDepartment": "Phòng ban mới",
            "newJobPosition": "Vị trí mới",
            "newJobTitle": "Chức vụ mới",
            "newContractType":" Hợp đồng mới",
            "description": "Nhập mô tả",
            "pending": "Chờ duyệt",
            "reject": "Từ chối",
            "approved": "Đã duyệt",
            "trashed": "Đã bị xóa",
            "jobPosition": "Nhập Chức vụ",
            "jobTitle": "Nhập Vị trí",
            "contractType": "Nhập Loại hợp đồng",
            "reason":"Chọn lý do"

        },
        "label": {
            "decisionNo": "Số quyết định",
            "decisionDate": "Ngày quyết định",
            "decisionMaker": "Cấp ra quyết định",
            "validityDate": "Ngày hiệu lực",
            "employee": "Nhân viên",
            "reasonDecision": "Lý do",
            "currentDepartment": "Phòng ban cũ",
            "currentJobPosition": "Vị trí cũ",
            "currentJobTitle": "Chức vụ cũ",
            "currentContractType":" Hợp đồng cũ",
            "newDepartment": "Phòng ban mới",
            "newJobPosition": "Vị trí mới",
            "newJobTitle": "Chức vụ mới",
            "newContractType":" Hợp đồng mới",
            "description": "Mô tả",
            "status": "Trạng thái",
            "reason": "Lý do",
            "type": "Loại quyết định",
            "decisionObject": "Đối tượng",
            "createDate":"Ngày tạo",
            "createName" : "Người tạo",
            "approvedName" : "Người xử lý",
            "department" : "Phòng ban",
            "jobPosition" : "Vị trí" ,
            "jobTitle" : "Chức vụ",
            "reprimandMethod" : "Hình thức",
            "amount" : "Tiền lương",
            "amountBonus" : "Tiền thưởng"

        },

        "tabs": {
            "transfer": "Điều chuyển",
            "reward": "Khen thưởng",
            "contract": "Chấm dứt hợp đồng",
            "discipline": "Kỷ luật lao động",
            "salary": "Điều chỉnh lương",
            "admission": "Tiếp nhận",
            "appointment": "Bổ nhiệm",
            "dismissal": "Miễn nhiệm",
            "all": "Tất cả"
        },
    },
    ...DismissalDecisionVI,
    ...SalaryDecisionVI,
    ...RewardDecisionVI,
    ...AppointmentDecisionVI,
    ...AdmissionDecisionVI,
    ...ReasonVI,
    ...TransferDecisionVI,
    ...ContractDecisionVI
}